'use strict';

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject;
var VisuallyHidden = styled__default["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n    border-width: 0;\n    clip: rect(0, 0, 0, 0);\n    clip-path: inset(50%);\n    height: 0;\n    margin: 0;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 0;\n"])));

exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.style-195957c9.js.map
